<template>
  <div class="ts-bg-white ts-rounded-lg ts-p-5">
    <!-- <h3 class="ts-rounded-xl ts-font-robot ts-text-lg">{{ $t('dashboard.betting') }}</h3> -->
    <a-skeleton :active="active" :loading="active" width="10px" :paragraph="{ rows: 5 }" />
    <div v-if="!active" class="ts-flex ts-justify-between">      
      <div class="ts-grid ts-grid-cols-1 ts-gap-2">
        <div class="ts-w-full ts-p-2 ts-rounded-lg">
          <div class="ts-flex ts-items-center">
            <div
              class="ts-w-10 ts-h-10 ts-rounded-lg ts-bg-yellow-200 ts-flex ts-items-center ts-justify-center"
            >
              <i class="fas fa-ticket-alt ts-fill-current ts-text-yellow-800"></i>
            </div>
            <div class="ts-h-10 ts-ml-4">
              <h5
                class="ts-font-heading-font ts-mb-0 ts-text-base ts-font-bold ts-text-para-color"
              >{{ bets.no_number_ticket }}</h5>
              <p class="ts-font-robot ts-tracking-wide">{{ $t('dashboard.numberOfTicketToday') }}</p>
            </div>
          </div>
        </div>
        <div class="ts-w-full ts-p-2 ts-rounded-lg">
          <div class="ts-flex ts-items-center">
            <div
              class="ts-w-10 ts-h-10 ts-rounded-lg ts-bg-pink-200 ts-flex ts-items-center ts-justify-center"
            >
              <i class="fas fa-list ts-fill-current ts-text-red-600"></i>
            </div>
            <div class="ts-h-10 ts-ml-4">
              <h5
                class="ts-font-heading-font ts-mb-0 ts-text-base ts-font-bold ts-text-para-color"
              >{{ bets.no_line }}</h5>
              <p class="ts-font-robot ts-tracking-wide">{{ $t('dashboard.numberOfLinetoday') }}</p>
            </div>
          </div>
        </div>
        <div class="ts-w-full ts-p-2 ts-rounded-lg">
          <div class="ts-flex ts-items-center">
            <div
              class="ts-w-10 ts-h-10 ts-rounded-lg ts-bg-yellow-200 ts-flex ts-items-center ts-justify-center"
            >
              <i class="fas fa-check-double ts-fill-current ts-text-yellow-600"></i>
            </div>
            <div class="ts-h-10 ts-ml-4">
              <h5 class="ts-font-heading-font ts-mb-0 ts-text-base ts-font-bold ts-text-pink-600">{{ bets.no_betting }}</h5>
              <p class="ts-font-robot ts-tracking-wide">{{ $t('dashboard.numberOfBettingToday') }}</p>
            </div>
          </div>
        </div>
        <div class="ts-w-full ts-p-2 ts-rounded-lg">
          <div class="ts-flex ts-items-center">
            <div
              class="ts-w-10 ts-h-10 ts-rounded-lg ts-bg-pink-200 ts-flex ts-items-center ts-justify-center"
            >
              <i class="far fa-money-bill-alt ts-fill-current ts-text-red-600"></i>
            </div>
            <div class="ts-h-10 ts-ml-4">
              <h5 class="ts-font-heading-font ts-mb-0 ts-text-base ts-font-bold ts-text-blue-600">{{ bets.amount }}</h5>
              <p class="ts-font-robot ts-tracking-wide">{{ $t('dashboard.totalBettingAmountToday') }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="ts-w-1/3 ts-flex ts-items-center ts-justify-center">
        <h1 class="ts-text-6xl ts-font-heading-font ts-border ts-p-2 ts-rounded-full">{{ today }}</h1>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import moment from 'moment'
export default {
  name: 'betting',
  data() {
    return {
      active: false,
      today: moment().format('DD'),
      bets: {}
    }
  },
  created(){
    this.onFetchData()
  },
  methods: {
    ...mapActions('dashboard/record', ['betting']),
    onFetchData(){
      this.active = true
      this.betting()
        .then(response => {
          this.bets = response.data
        })
        .finally(() => {
          this.active = false
        })
    }
  }
}
</script>